import React from "react";

class DropdownContaConcil extends React.Component {
  render() {
    return (
      <React.Fragment>
        <option></option>
        <option value="0211100000">211100000 - CLIENTES GERAIS</option>
        <option value="0211300000">
          211300000 - CLIENTES - EMPRESAS SUBSIDIARIAS
        </option>
        <option value="0211400000">
          211400000 - CLIENTES - EMPRESAS ASSOCIADAS
        </option>
        <option value="0211600000">
          211600000 - CLIENTES - OUTRAS PARTES RELACIONADAS
        </option>
        <option value="0211700000">
          211700000 - CLIENTES SUBSIDIOS À EXPLORAÇÃO
        </option>
        <option value="0212100000">
          212100000 - CLIENTES GERAIS - TITULOS A RECEBER
        </option>
        <option value="0213100000">
          213100000 - CLIENTES COBRANÇA DUVIDOSA - GERAIS
        </option>
        <option value="0213100001">
          213100001 - CLIENTES COBR DUVID.- GERAIS - AJUSTE SALDO CREDOR
        </option>
        <option value="0213100002">
          213100002 - CLIENTES COBR DUVID.-GERAIS - DESTINO SALDO CREDOR
        </option>
        <option value="0213300000">
          213300000 - CLIENTES COBRANÇA DUVIDOSA - EMPRESAS SUBSIDIARIAS
        </option>
        <option value="0213300001">
          213300001 - CLIENTES COBR.DUVID.-EMPR.SUBSID.AJUSTE SALDO CRED
        </option>
        <option value="0213300002">
          213300002 - CLIENTES COBR.DUVID.-EMPR.SUBS.DESTINO SALDO CRED
        </option>
        <option value="0213400000">
          213400000 - CLIENTES COBRANÇA DUVIDOSA - EMPRESAS ASSOCIADAS
        </option>
        <option value="0213400001">
          213400001 - CLIENTES COBR.DUVID.-EMPR.ASSOC.-AJUSTE SALDO CRED
        </option>
        <option value="0213400002">
          213400002 - CLIENT.COBR.DUVID.-EMPR.ASSOC.-DESTINO SALDO CRED
        </option>
        <option value="0213600000">
          213600000 - CLIENTES COBR.DUVID. - OUTRAS PARTES RELACIONADAS
        </option>
        <option value="0213600001">
          213600001 - CLIENT.COB.DUVID.OUT PARTES RELAC.AJUSTE SALD.CRED
        </option>
        <option value="0213600002">
          213600002 - CLIENT.COB.DUVID.OUT PARTES RELAC.DESTIN.SALD.CRED
        </option>
        <option value="0214100000">
          214100000 - CLIENTES C/ FACTURAS EM FACTORING
        </option>
        <option value="0214200000">
          214200000 - CLIENTES C/ FACTURAS EM EUROFACTOR
        </option>
        <option value="0218000000">
          218000000 - ADIANTAMENTOS DE CLIENTES
        </option>
        <option value="0218400000">
          218400000 - ADIANTAM. CLIENTES COM RECURSO DE FACTORING
        </option>
        <option value="0218700000">
          218700000 - ADIANT. CLIENTES - SUBSIDIOS À EXPLORAÇÃO
        </option>
        <option value="0272100004">
          272100004 - PREST.SERV./CLIENTES - PROV. A PARTIR JUN/09
        </option>
        <option value="0272160000">
          272160000 - SUBSIDIOS A EXPLORACAO - A RECEBER
        </option>
        <option value="0272180000">
          272180000 - PRESTAÇÕES SERVIÇO/PROJ. INTERNACIONAIS-A RECEBER
        </option>
        <option value="0278110000">278110000 - DEVEDORES DIVERSOS</option>
        <option value="0278110001">
          278110001 - ADIANTAMENTOS DE OUTROS DEVEDORES
        </option>
        <option value="0278110002">
          278110002 - VENDA PARTICIPAÇÕES-ADIANTAM. DE OUTROS DEVEDORES
        </option>
        <option value="0278110003">
          278110003 - OUTROS DEVEDORES POR SUPRIMENTOS CONCEDIDOS
        </option>
        <option value="0278110005">
          278110005 - OUTROS DEVEDORES - DIVIDENDOS DE PARTICIPADAS
        </option>
        <option value="0278110006">
          278110006 - OUTROS DEVEDORES POR COBERTURA DE PREJUIZOS
        </option>
        <option value="0278110007">
          278110007 - OUTROS DEVEDORES - VENDA DE PARTICIPAÇÕES-M.PRAZO
        </option>
        <option value="0278120000">
          278120000 - OUTROS DEVEDORES - CAUÇÕES
        </option>
        <option value="0278130000">
          278130000 - SOCIOS - VALORES EM COBRANÇA
        </option>
        <option value="0278140000">
          278140000 - ADIANTAMENTOS A OUTROS DEVEDORES
        </option>
        <option value="0278140001">
          278140001 - ADIANT.A OUTROS DEVEDORES - SUPRIMENTOS
        </option>
        <option value="0278140002">
          278140002 - PREST.SUPLEM./ACESSORIAS-ADIANT.OUTROS DEVEDORES
        </option>
        <option value="0278150000">
          278150000 - DEVEDORES POR EMISSÃO DE RECIBOS SEM RECEBI/PRÉVIO
        </option>
        <option value="0282100001">
          282100001 - PREST.SERV. / PROJ.INT.-REC.ANTECIPADOS
        </option>
        <option value="0282100002">
          282100002 - SUBS. À EXPLORACAO - RECEB.ANTECIPADOS
        </option>
        <option value="0593000001">
          593000001 - SUBSIDIOS PARA INVESTIMENTOS - ADIANTAMENTOS
        </option>
        <option value="0593000002">
          593000002 - SUBS P/INVESTIM.IMOBILIZ. DEFINITIVO-VAL.RECEBIDO
        </option>
        <option value="0O11000000">
          O11000000 - DEVEDORES P/ LETRAS DESCONTADAS
        </option>
        <option value="0O21999999">
          O21999999 - SOLICITAÇÃO DE ADIANTAMENTO CLIENTES
        </option>
        <option value="0O31000000">
          O31000000 - DEVEDORES P/ GARANTIAS BANCÁRIAS CONCEDIDAS
        </option>
        <option value="0O33000000">
          O33000000 - DEVEDORES P/ FIANÇAS E AVALES PRESTADOS
        </option>
        <option value="0O35000000">
          O35000000 - DEVEDORES P/ CARTAS CONFORTO CONCEDIDAS
        </option>
        <option value="0O43000000">
          O43000000 - DEVEDORES P/ CONSTITUIÇÃO DE HIPOTECA (ISQ)
        </option>
        <option value="0O45000000">
          O45000000 - DEVEDORES-RESPONSAB.P/FACTURAS EM FACTORING
        </option>
        <option value="0O51000000">
          O51000000 - DEVEDORES - RESPONS.P/CREDITOS CEDIDOS
        </option>
      </React.Fragment>
    );
  }
}

export default DropdownContaConcil;
